import React from "react";
import ModalFormUI from "../../../widgets/form/ModalFormUI";
import InputTextSF from "../../../widgets/form/InputTextSF";
import InputSelectSF from "../../../widgets/form/InputSelectSF";


const GSTAddModalUI = ({
	context, successMsg, errorList, setErrorList,
	createMode, onSubmit, submitted, onCancelCreate,
	gstNumber, onGstNumberChange, gstNumberError, setGstNumberError,
	state, onStateChange, stateError, setStateError,

}) =>
	<ModalFormUI
		context={context}
		titleLabel='Add GST Number'
		buttonLabel='Add'
		cancelLabel='Cancel'
		isOpen={createMode}
		onRequestClose={onCancelCreate}
		successMsg={successMsg}
		errorList={errorList}
		setErrorList={setErrorList}
		onSubmit={onSubmit}
		busy={submitted}
	>

		<div className='col'>
			<InputTextSF type='text' name='gstNumber'
				label='GST Number'
				value={gstNumber} onChange={onGstNumberChange}
				error={gstNumberError} setError={setGstNumberError}
			/>
			<InputTextSF type='text' name='state' maxLength={40}
				label='State'
				value={state} onChange={onStateChange}
				error={stateError} setError={setStateError}
			/>

		</div>

	</ModalFormUI>

export default GSTAddModalUI;
